<template>
  <div class="container-fluid">
    <div class="row mb-2">
      <h4 class="col-5">
        {{ $t('config.title') }}
      </h4>
    </div>
    <ul class="nav nav-tabs" role="tablist">
      <li class="nav-item">
        <a id="licence-tab" class="nav-link active" data-toggle="tab" href="#licence" role="tab" aria-controls="licence" aria-selected="true"> {{ $t('config.license') }}</a>
      </li>
      <li class="nav-item">
        <a id="mail-tab" class="nav-link" data-toggle="tab" href="#mail" role="tab" aria-controls="mail" aria-selected="false">{{ $t('config.mail') }}</a>
      </li>
      <li class="nav-item">
        <a id="tickets-tab" class="nav-link" data-toggle="tab" href="#tickets" role="tab" aria-controls="tickets" aria-selected="false">{{ $t('config.issue') }}</a>
      </li>
      <li class="nav-item">
        <a id="maintenance-tab" class="nav-link" data-toggle="tab" href="#maintenance" role="tab" aria-controls="maintenance" aria-selected="false">{{ $t('config.maintenance') }}</a>
      </li>
      <li class="nav-item">
        <a id="logs-tab" class="nav-link" data-toggle="tab" href="#logs" role="tab" aria-controls="logs" aria-selected="false" @click="getLogs">{{ $t('config.logs') }}</a>
      </li>
    </ul>
    <div id="settingsTab" class="tab-content">
      <div id="licence" class="tab-pane fade show active pt-2" role="tabpanel" aria-labelledby="licence-tab">
        <div class="license-info">
          <span class="license-badge" :class="'license-badge--' + (licenseStatus || 'active')">{{ licenseStatusLabel }}</span>
          <span v-if="config.license.expirationDate" class="license-date">
            Próximo vencimiento: {{ formatDate(config.license.expirationDate) }}
          </span>
          <span v-else class="license-date license-date--muted">
            Sin fecha de vencimiento configurada.
          </span>
        </div>
      </div>
      <div id="mail" class="tab-pane fade pt-2" role="tabpanel" aria-labelledby="mail-tab">
        <div class="container-fluid row">
          <div class="col-12 mb-4">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Host</span>
              </div>
              <input v-model="config.mail.hostname" autocomplete="disabled" placeholder="Ingrese el servidor host" type="text" class="form-control" name="host">
              <div class="input-group-prepend">
                <span class="input-group-text">Puerto</span>
              </div>
              <input v-model="config.mail.port" autocomplete="disabled" placeholder="Ingrese el Puerto" type="number" class="form-control" name="port">
            </div>
            <span class="alert-msg" />
          </div>
          <div class="col-12 mb-4">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Usuario</span>
              </div>
              <input v-model="config.mail.username" autocomplete="disabled" placeholder="Usuario del host" class="form-control" name="user">
              <div class="input-group-prepend">
                <span class="input-group-text">Contraseña</span>
              </div>
              <input v-model="config.mail.password" :type="passwordFieldType" autocomplete="disabled" placeholder="Contraseña del host" class="form-control" name="passwd">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" @click="switchVis">
                  <span v-if="passwordFieldType==='password'">Mostrar</span>
                  <span v-else>Ocultar</span>
                </button>
              </div>
            </div>
            <span class="alert-msg" />
          </div>
          <div class="col-12 mb-4">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">smtp.auth</span>
              </div>
              <div class="form-control">
                <input type="checkbox">
              </div>
              <div class="input-group-prepend">
                <span class="input-group-text">starttls.enable</span>
              </div>
              <div class="form-control">
                <input type="checkbox">
              </div>
            </div>
            <span class="alert-msg" />
          </div>
          <button type="button" class="btn btn-primary" @click="setMailConfig()">
            {{ $t('action.save') }}
          </button>
        </div>
      </div>
      <div id="tickets" class="tab-pane fade pt-2" role="tabpanel" aria-labelledby="tickets-tab">
        <div class="container-fluid row">
          <div class="col-12 mb-4">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Crear usuario automáticamente para nuevos clientes.</span>
              </div>
              <div class="form-control">
                <input v-model="config.ticket.customerCreatesUser" type="checkbox">
              </div>
              <div class="input-group-prepend">
                <span class="input-group-text">---</span>
              </div>
              <div class="form-control">
                <input type="checkbox">
              </div>
            </div>
            <span class="alert-msg" />
          </div>
          <div class="col-12">
            Envíos de notificaciones.
          </div>
          <div class="col-12 mb-4">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Al crear ticket enviar correo al Cliente.</span>
              </div>
              <div class="form-control">
                <input v-model="config.ticket.onCreateSendEmailCustomer" type="checkbox">
              </div>
              <div class="input-group-prepend">
                <span class="input-group-text">Al asignar ticket enviar correo al Técnico.</span>
              </div>
              <div class="form-control">
                <input v-model="config.ticket.onAssignSendEmailTechnician" type="checkbox">
              </div>
              <div class="input-group-prepend">
                <span class="input-group-text">Al cerrar ticket enviar correo al Cliente.</span>
              </div>
              <div class="form-control">
                <input v-model="config.ticket.onCloseSendEmailCustomer" type="checkbox">
              </div>
            </div>
            <span class="alert-msg" />
          </div>
        </div>
      </div>
      <div id="maintenance" class="tab-pane fade pt-2" role="tabpanel" aria-labelledby="maintenance-tab">
        <div class="container row mb-3">
          <button class="btn btn-danger col-5" @click="rebootServer">
            Reiniciar Servidor / Respaldo BD
          </button>
          <button class="btn btn-warning col-5 ml-3" @click="clearCache">
            Limpiar Caché
          </button>
        </div>
        <div class="col-4 mb-3 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">Idioma</span>
          </div>
          <select v-model="config.local.selected" class="form-control form-select">
            <option v-for="(local, index) in supportedLocales" :key="index" :value="local">
              {{ $t('menu.' + local) }}
            </option>
          </select>
        </div>
        <div class="col-12 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">duración de la sesión</span>
          </div>
          <input autocomplete="disabled" required placeholder="renovación de tokens" type="number" class="form-control" name="port">
        </div>
        <button type="button" class="btn btn-primary" @click="setLocalConfig()">
          {{ $t('action.save') }}
        </button>
      </div>
      <div id="logs" class="tab-pane fade pt-2" role="tabpanel" aria-labelledby="logs-tab">
        <log-component ref="logComponent" />
      </div>
    </div>
  </div>
</template>
<script>
import LogComponent from './components/LogComponent';
import ConfigService from '@/services/config.service';
import { Trans } from '@/plugins/Translation';
import { formatDate, getLicenseStatus } from '@/utils/page-utils';

export default {
    name: 'Settings',
    components: { LogComponent },
    data() {
        return {
            passwordFieldType: 'password',
            config: {
                mail: {
                    hostname: '',
                    port: '',
                    username: '',
                    password: '',
                },
                local: {
                    selected: 'es'
                },
                ticket: {
                    customerCreatesUser: false,
                    onCreateSendEmailCustomer: false,
                    onAssignSendEmailTechnician: false,
                    onCloseSendEmailCustomer: false
                },
                license: {
                    expirationDate: null
                }
            }
        };
    },
    computed: {
        supportedLocales() {
            return Trans.supportedLocales;
        },
        licenseStatus() {
            return getLicenseStatus(this.config.license.expirationDate).status;
        },
        licenseStatusLabel() {
            if (this.licenseStatus === 'expired') {
                return 'Vencida';
            }
            if (this.licenseStatus === 'warning') {
                return 'Por vencer';
            }
            return 'Activa';
        }
    },
    created() {
        ConfigService.getMailConfig().then(
            response => {
                this.config.mail = response.data;
            },
            error => {
                console.log(error.response && error.response.data ||
          error.message || error.toString());
            }
        );
        ConfigService.getLocalConfig().then(
            response => {
                this.config.local.selected = response.data.selected;
            },
            error => {
                console.log(error.response && error.response.data ||
          error.message || error.toString());
            }
        );
        ConfigService.getLicenseInfo().then(
            response => {
                this.config.license.expirationDate = response.data && response.data.expirationDate;
            },
            error => {
                console.log(error.response && error.response.data ||
          error.message || error.toString());
            }
        );
        // ConfigService.getTicketConfig().then(
        //     response => {
        //         this.config.ticket = response.data;
        //     },
        //     error => {
        //         console.log(error.response && error.response.data ||
        //   error.message || error.toString());
        //     }
        // );
    },
    methods: {
        formatDate,
        switchVis() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
        clearCache() {
            ConfigService.clearCache().then(
                response => {
                    alert('Limpieza de caché ok.');
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        setMailConfig() {
            var data = this.config.mail;
            ConfigService.setMailConfig(data).then(
                response => {},
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        setLocalConfig() {
            var data = {selected: this.config.local.selected};
            var self = this;
            ConfigService.setLocalConfig(data).then(
                response => {
                    Trans.changeLocale(data.selected).then(() => {
                        // we should PERSIST this data.
                        self.$store.dispatch('settings/changeSetting', {
                            key: 'locale',
                            value: data.selected
                        });
                    });
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        rebootServer() {
            ConfigService.rebootServer().then(
                response => {
                    alert('Reiniciando, aguarde 1 minuto.');
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        getLogs() {
            this.$refs.logComponent.initLogsComponent();
        }
    }
};
</script>
<style lang="scss">
@import "../../styles/theme.scss";

#settingsTab {
    height: 75vh;
    border: 1px solid #e8ebee;
    border-top: none;
    border-radius: 5px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    padding-left: 10px;
    overflow: auto;
}

.license-info {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 4px 0;
}

.license-badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.02em;

    &--active {
        color: darken($issue-success, 8%);
        background-color: $issue-success-soft;
    }
    &--warning {
        color: darken($issue-warning, 20%);
        background-color: $issue-warning-soft;
    }
    &--expired {
        color: darken($issue-danger, 5%);
        background-color: $issue-danger-soft;
    }
}

.license-date {
    font-size: 14px;
    color: $issue-text;

    &--muted {
        color: $issue-text-muted;
        font-style: italic;
    }
}
</style>
